import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";

@Component({
    selector: 'app-dashboard-chart',
    templateUrl: './dashboard-chart.component.html',
    styleUrls: ['./dashboard-chart.component.scss']
})
export class DashboardChartComponent implements OnInit {
    @Input() chartData: ApexOptions;

    constructor() {
    }

    ngOnInit(): void {
    }

}
